import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {I18nModule, UrlModule} from '@spartacus/core';
import {CustomFacetComponent} from './custom-facet.component';
import {KeyboardFocusModule} from '@spartacus/storefront';
import {CustomIconsModule} from 'src/app/custom/icons/custom-icons.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    CustomIconsModule,
    KeyboardFocusModule,
  ],
  declarations: [CustomFacetComponent],
  exports: [CustomFacetComponent],
})
export class CustomFacetModule {}
